<template>
  <div class="nf">
    <h1>啊哦！</h1>
    <span>请求的资源不存在的说>_<</span>
  </div>
</template>

<script>
export default {
  name: "404"
};
</script>

<style>
.nf {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: flex-start;
}
.nf h1 {
  position: relative;
  color: #dc9495;
  letter-spacing: 2px;
  line-height: 1.7rem;
}
.nf span {
  color: #dc9495;
  font-size: 1.3rem;
  letter-spacing: 2px;
  line-height: 1.7rem;
}
</style>